export const onlyDigitsRegexp: RegExp = new RegExp(/^\d+$/);
